import React from 'react';
import { useShowContext } from 'framework/show';
import { ControlledList, DataGridLayout } from 'framework/list';
import { EnumField, TextField } from 'framework/ui/field';
import { KPI_TYPES_UNIT_OPTIONS } from '../../useKPIService';

const KpiParametersListField = ({ source, dateSource }: { source: string; dateSource: string }) => {
  const { data } = useShowContext();
  const requestPositions = data.getValueBySource(source);

  return (
    <ControlledList data={{ items: requestPositions, totalPages: 1, totalElements: requestPositions?.length }}>
      <DataGridLayout customEmptyMessage="No parameters found">
        <TextField label="Name" source="name" width="30%" />

        <EnumField label="Type" source="type" options={KPI_TYPES_UNIT_OPTIONS} />
      </DataGridLayout>
    </ControlledList>
  );
};

export default KpiParametersListField;
